import {
  SlatwalApiService,
  axios,
  getErrorMessage,
} from "@ten24/slatwall-storefront-react-private/global";

import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const useAccountOverview = ({ tradeOrderListing = 0 }) => {
  const [orders, setOrders] = useState([]);
  const pageRecordsShow = 5;
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    let source = axios.CancelToken.source();
    let headers = {};
    const params = { tradeOrderListing, pageRecordsShow, currentPage };
    SlatwalApiService.account
      .orders(params, headers, source)
      .then((response) => {
        if (
          response.isSuccess() &&
          Object.keys(response.success()?.errors || {}).length
        )
          toast.error(getErrorMessage(response.success().errors));
        if (response.isSuccess()) {
          setOrders({
            data: response.success().ordersOnAccount,
            isFetching: false,
            isLoaded: true,
            makeRequest: false,
            params: {},
          });
        } else {
          setOrders({
            data: {},
            isFetching: false,
            makeRequest: false,
            isLoaded: true,
            params: {},
            error: "Something was wrong",
          });
        }
      });
  }, [tradeOrderListing, pageRecordsShow, currentPage]);

  return { orders, pageRecordsShow, currentPage, setCurrentPage };
};

export { useAccountOverview };
